import React, {useState} from 'react'

function AboutTimeline({data}) {

    const [activeClass, setActiveClass] = useState(0);
    const toggleClick =((index) =>{
        setActiveClass(index);
    })
  return (

    <>
        
        <section className='about-timeline'>
            <div className='container'>
                <div className='timeline-cont'>
                    {
                        data.map((responce, index) =>{
                            const {imgCont, date, Description} = responce;
                            return(
                                <div className={activeClass === index ? "content active-content" : "content"} key={index}>
                                    <div className='timeline-img' >
                                        <img src={imgCont} alt=''/>
                                    </div>
                                    <div className='timeline-date'>
                                        <h4>{date}</h4>
                                    </div>
                                    <div className='timeline-descrption'>
                                        <p className='sm-para' dangerouslySetInnerHTML={{ __html: Description }}></p>
                                    </div>
                                </div>
                            )
                        })
                    }
                    
                </div>
                <div className='timeline-list-sub'>
                    <ul className='timeline-list'>
                        {
                            data.map((responce, index) =>{
                                return(
                                    <li className={activeClass === index ? "sm-class active" : "sm-class" }
                                        onClick={() =>{ toggleClick(index);} }
                                        key={index}>
                                        {responce.date}
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            </div>
        </section>

        
    </>
  )
}

export default AboutTimeline